export const FETCH_ASSETSECURITY_BEGIN="FETCH_ASSETSECURITY_BEGIN";
export const FETCH_ASSETSECURITY_SUCCESS="FETCH_ASSETSECURITY_SUCCESS";
export const FETCH_ASSETSECURITY_FAILURE="FETCH_ASSETSECURITY_FAILURE";

export const FETCH_ASSETINVESTMENT_BEGIN="FETCH_ASSETINVESTMENT_BEGIN";
export const FETCH_ASSETINVESTMENT_SUCCESS="FETCH_ASSETINVESTMENT_SUCCESS";
export const FETCH_ASSETINVESTMENT_FAILURE="FETCH_ASSETINVESTMENT_FAILURE";


export const FETCH_ASSETCLASS_BEGIN="FETCH_ASSETCLASS_BEGIN";
export const FETCH_ASSETCLASS_SUCCESS="FETCH_ASSETCLASS_SUCCESS";
export const FETCH_ASSETCLASS_FAILURE="FETCH_ASSETCLASS_FAILURE";



export const FETCH_FUNDSTATUS_BEGIN="FETCH_FUNDSTATUS_BEGIN";
export const FETCH_FUNDSTATUS_SUCCESS="FETCH_FUNDSTATUS_SUCCESS";
export const FETCH_FUNDSTATUS_FAILURE="FETCH_FUNDSTATUS_FAILURE";

export const FETCH_PRIMARYANALYST_BEGIN="FETCH_PRIMARYANALYST_BEGIN";
export const FETCH_PRIMARYANALYST_SUCCESS="FETCH_PRIMARYANALYST_SUCCESS";
export const FETCH_PRIMARYANALYST_FAILURE="FETCH_PRIMARYANALYST_FAILURE";

export const FETCH_SECONDARYANALYST_BEGIN="FETCH_SECONDARYANALYST_BEGIN";
export const FETCH_SECONDARYANALYST_SUCCESS="FETCH_SECONDARYANALYST_SUCCESS";
export const FETCH_SECONDARYANALYST_FAILURE="FETCH_SECONDARYANALYST_FAILURE";

export const FETCH_STRATEGY_BEGIN="FETCH_STRATEGY_BEGIN";
export const FETCH_STRATEGY_SUCCESS="FETCH_STRATEGY_SUCCESS";
export const FETCH_STRATEGY_FAILURE="FETCH_STRATEGY_FAILURE";

export const FETCH_SUBSTRATEGY_BEGIN="FETCH_SUBSTRATEGY_BEGIN";
export const FETCH_SUBSTRATEGY_SUCCESS="FETCH_SUBSTRATEGY_SUCCESS";
export const FETCH_SUBSTRATEGY_FAILURE="FETCH_SUBSTRATEGY_FAILURE";

export const FETCH_REGION_BEGIN="FETCH_REGION_BEGIN";
export const FETCH_REGION_SUCCESS="FETCH_REGION_SUCCESS";
export const FETCH_REGION_FAILURE="FETCH_REGION_FAILURE";


export const FETCH_SUBREGION_BEGIN="FETCH_SUBREGION_BEGIN";
export const FETCH_SUBREGION_SUCCESS="FETCH_SUBREGION_SUCCESS";
export const FETCH_SUBREGION_FAILURE="FETCH_SUBREGION_FAILURE";

export const FETCH_SECTOR_BEGIN="FETCH_SECTOR_BEGIN";
export const FETCH_SECTOR_SUCCESS="FETCH_SECTOR_SUCCESS";
export const FETCH_SECTOR_FAILURE="FETCH_SECTOR_FAILURE";

export const FETCH_SUBSECTOR_BEGIN="FETCH_SUBSECTOR_BEGIN";
export const FETCH_SUBSECTOR_SUCCESS="FETCH_SUBSECTOR_SUCCESS";
export const FETCH_SUBSECTOR_FAILURE = "FETCH_SUBSECTOR_FAILURE";

export const FETCH_ASSETAUMDETAILS_BEGIN = "FETCH_ASSETAUMDETAILS_BEGIN";
export const FETCH_ASSETAUMDETAILS_SUCCESS = "FETCH_ASSETAUMDETAILS_SUCCESS";
export const FETCH_ASSETAUMDETAILS_FAILURE = "FETCH_ASSETAUMDETAILS_FAILURE";

export const FETCH_ASSETRETURNS_BEGIN   = "FETCH_ASSETRETURNS_BEGIN";
export const FETCH_ASSETRETURNS_SUCCESS ="FETCH_ASSETRETURNS_SUCCESS";
export const FETCH_ASSETRETURNS_FAILURE ="FETCH_ASSETRETURNS_FAILURE";

export const  FETCH_ASSETSHARECLASSTERMS_BEGIN= "FETCH_ASSETSHARECLASSTERMS_BEGIN";
export const FETCH_ASSETSHARECLASSTERMS_SUCCESS="FETCH_ASSETSHARECLASSTERMS_SUCCESS";
export const FETCH_ASSETSHARECLASSTERMS_FAILURE="FETCH_ASSETSHARECLASSTERMS_FAILURE";

export const FETCH_ASSETPRIVATEEXPOSURE_BEGIN= "FETCH_ASSETPRIVATEEXPOSURE_BEGIN";
export const FETCH_ASSETPRIVATEEXPOSURE_SUCCESS="FETCH_ASSETPRIVATEEXPOSURE_SUCCESS";
export const FETCH_ASSETPRIVATEEXPOSURE_FAILURE="FETCH_ASSETPRIVATEEXPOSURE_FAILURE";